export const SAVE_INITIAL_TIMEOUT = 5000;
export const SAVE_COUNTDOWN_INTERVAL = 500;



// WEBPACK FOOTER //
// ./src/constants/time.js